(() => {
  function init(root) {
    if (root.dataset.purativeReady) return;
    root.dataset.purativeReady = 'true';
    // Event hooks contain no contact details. Analytics integrations can subscribe
    // after applying the store's consent policy; this does not load a tracker.
    const emit = name => document.dispatchEvent(new CustomEvent('purative:analytics', {
      detail: { event: name, path: location.pathname }
    }));
    emit('purative_page_view');
    if (root.querySelector('.p-pdp-grid')) emit('pdp_view');
    root.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      if (detail.id === 'purative-compare') emit('product_compare');
      else if (detail.closest('#purative-evidence')) emit('certification_expand');
    }));
    const form = root.querySelector('.p-form');
    const inquiry = form?.querySelector('[data-purative-inquiry]');
    const updateIntent = () => {
      if (!inquiry) return;
      const preorder = inquiry.value === 'Ordering questions';
      form.querySelectorAll('[data-purative-review-field]').forEach(field => {
        field.hidden = preorder;
        field.querySelectorAll('input,select').forEach(input => { input.disabled = preorder; });
      });
      form.querySelector('[data-purative-submit]').textContent = preorder ? 'Send my ordering question ↗' : (root.classList.contains('p-story-landing') && inquiry.value === 'Water review' ? 'Request a water review ↗' : 'Send my request ↗');
    };
    inquiry?.addEventListener('change', updateIntent);
    root.querySelectorAll('[data-purative-intent]').forEach(link => link.addEventListener('click', () => {
      if (inquiry) { inquiry.value = link.dataset.purativeIntent; updateIntent(); }
      if (link.dataset.purativeIntent === 'Installation') emit('installation_request');
    }));
    root.querySelectorAll('[data-purative-compare]').forEach(link => link.addEventListener('click', () => {
      const compare = root.querySelector('#purative-compare');
      if (compare) compare.open = true;
    }));
    const spec = root.querySelector('.p-spec-details');
    if (spec && matchMedia('(min-width: 651px)').matches) spec.open = true;
    if (form) {
      const pendingKey = 'purative-request';
      form.addEventListener('submit', () => {
        if (!form.checkValidity() || form.hasAttribute('data-purative-preview-form')) return;
        try { sessionStorage.setItem(pendingKey, JSON.stringify({ type: inquiry?.value || 'Replacement availability', at: Date.now() })); } catch (_) {}
      });
      if (root.querySelector('.p-success')) {
        try {
          const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
          if (pending && Date.now() - pending.at < 3600000) {
            emit(pending.type === 'Ordering questions' ? 'preorder_submit' : pending.type === 'Replacement availability' ? 'replacement_availability_submit' : 'consultation_submit');
            sessionStorage.removeItem(pendingKey);
          }
        } catch (_) {}
      }
    }
    root.querySelectorAll('[data-purative-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        const image = root.querySelector('[data-purative-main-image]');
        if (!image) return;
        image.src = button.dataset.src;
        image.removeAttribute('srcset');
        image.alt = button.dataset.alt || '';
        root.querySelectorAll('[data-purative-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    // The local review server has no mail or checkout backend.
    root.querySelectorAll('[data-purative-preview-form]').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const status = form.querySelector('[role="status"]');
        status.hidden = false;
        status.textContent = 'Preview only — your request has not been sent.';
        status.focus();
      });
    });
  }
  document.querySelectorAll('[data-purative]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-purative]').forEach(init));
})();
